<div
  style="
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    background: #000000;
  "
>
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: var(--iframe-gap);
      align-items: center;
      background: var(--iframe-modal-bg);
      border-radius: 20px;
      padding: 20px;
      max-width: 320px;
      width: calc(100% - 40px);
      max-height: 90vh;
      overflow-y: auto;
    "
  >
    <!-- Header with logos -->
    <div style="display: flex; align-items: center; gap: 0; justify-content: center">
      <div style="width: 38px; height: 48px; z-index: 10; overflow: visible">
        {{#if displayLogo}}
        <img
          src="{{displayLogo}}"
          alt="{{displayName}}"
          style="width: 48px; height: 48px; border-radius: 24px; object-fit: cover"
        />
        {{else}}
        <span
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 24px;
            background-color: var(--iframe-button-bg);
            color: var(--iframe-button-text);
            font-size: 14px;
            font-weight: 600;
          "
          >A</span
        >
        {{/if}}
      </div>

      <!-- ------------------------------------------------------------ -->

      <div style="width: 38px; height: 48px; z-index: 5; overflow: visible">
        {{#if userAvatar}}
        <img
          src="{{userAvatar}}"
          alt="{{userName}}"
          style="width: 48px; height: 48px; border-radius: 24px; object-fit: cover"
        />
        {{else}}
        <span
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 48px;
            height: 48px;
            border-radius: 24px;
            background-color: var(--iframe-button-bg);
            color: var(--iframe-button-text);
            font-size: 14px;
            font-weight: 600;
          "
          >U</span
        >
        {{/if}}
      </div>
    </div>

    <!-- Transaction title -->

    <div style="display: flex; align-items: center; gap: var(--iframe-gap); justify-content: center">
      <span
        style="
          width: fit-content;
          font-size: var(--iframe-h1-fz);
          font-weight: var(--iframe-heading-fw);
          line-height: 150%;
          text-align: center;
        "
        >Confirm Transaction</span
      >
    </div>

    <!-- Application info -->
    <div class="domain-info {{domainStatusClass}}">
      <span style="display: block; width: 100%; font-size: 12px; text-align: center; font-family: monospace"
        >{{domainStatusText}} {{origin}}</span
      >
    </div>

    <!-- Transaction details box -->
    <div
      id="confirm-transaction-details-block"
      aria-expanded="false"
      style="display: flex; flex-direction: column; width: 100%"
    >
      <div
        id="confirm-transaction-details-toggler"
        style="
          cursor: pointer;
          text-align: center;
          list-style: none;
          padding: 0 var(--iframe-pd);
          user-select: none;
          font-size: 12px;
          line-height: 20px;
        "
      >
        Show Transaction Details ▼
      </div>

      <div
        id="confirm-transaction-details-content"
        style="
          display: flex;
          flex-direction: column;
          gap: var(--iframe-gap);
          width: 100%;
          max-height: var(--confirm-transaction-details-h, 0px);
          overflow: hidden;
          transition: max-height 300ms ease;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            gap: var(--iframe-gap);
            width: 100%;
            padding: var(--iframe-gap);
            border-radius: var(--iframe-el-bdrs);
            background: var(--iframe-info);
            font-size: 10px;
          "
        >
          {{#if fromAddress}}
          <div style="display: flex; justify-content: space-between">
            <strong style="color: var(--iframe-text-secondary); display: block">From:</strong>
            <a
              href="{{fromAddressExplorerUrl}}"
              target="_blank"
              rel="noopener noreferrer"
              style="word-break: break-all; display: block; color: #3b82f6; text-decoration: none"
              title="{{fromAddressFull}}"
            >
              <code>{{fromAddress}}</code>
            </a>
          </div>
          {{/if}}

          <!-- ------------------------------------------------------------ -->

          {{#if toAddress}}
          <div style="display: flex; justify-content: space-between">
            <strong style="color: var(--iframe-text-secondary); display: block">To:</strong>
            <a
              href="{{toAddressExplorerUrl}}"
              target="_blank"
              rel="noopener noreferrer"
              style="word-break: break-all; display: block; color: #3b82f6; text-decoration: none"
              title="{{toAddressFull}}"
            >
              <code>{{toAddress}}</code>
            </a>
          </div>
          {{/if}}

          <!-- ------------------------------------------------------------ -->

          {{#if hasValue}}
          <div style="display: flex; justify-content: space-between">
            <strong style="color: var(--iframe-text-secondary); display: block">Amount:</strong>
            <code style="word-break: break-all; display: block">{{formattedValue}}</code>
          </div>
          {{/if}}

          <!-- ------------------------------------------------------------ -->

          {{#if showContractInteraction}}
          <div style="display: flex; justify-content: space-between">
            <strong style="color: var(--iframe-text-secondary); display: block">Action:</strong>
            <code style="word-break: break-all; display: block">{{actionDescription}}</code>
          </div>
          {{/if}}

          <!-- ------------------------------------------------------------ -->

          <div style="display: flex; justify-content: space-between">
            <strong style="color: var(--iframe-text-secondary); display: block">Estimated Cost:</strong>
            <code style="word-break: break-all; display: block; color: #10b981">{{estimatedCost}}</code>
          </div>

          <!-- ------------------------------------------------------------ -->

          {{#if isSponsored}}
          <div
            style="
              display: flex;
              justify-content: space-between;
              background: var(--iframe-success);
              border-radius: var(--iframe-el-bdrs);
              padding: var(--iframe-gap);
            "
          >
            <span>Gas fees will be paid by the application (no cost to you)</span>
          </div>
          {{/if}}
        </div>
      </div>
    </div>

    <!-- ------------------------------------------------------------ -->

    {{#if showHighRisk}}
    <div class="security-warning">
      <strong>⚠️ {{riskLevel}} RISK</strong>
      {{riskReasons}}
    </div>
    {{else}}
    <div class="security-warning">Please verify this transaction carefully before confirming.</div>
    {{/if}}

    <!-- ------------------------------------------------------------ -->

    <div class="trust-app-section">
      <label class="trust-app-label">
        <input type="checkbox" class="trust-app-checkbox" />
        <span>Add this application to trusted list and skip confirmation for future transactions</span>
      </label>
    </div>

    <!-- Action buttons -->
    <div style="display: flex; gap: var(--iframe-gap); width: 100%; align-items: center">
      <button class="cancel-btn">Reject</button>
      <button class="confirm-btn">Confirm</button>
    </div>

    <!-- Footer notice -->
    <span
      style="
        display: block;
        padding: var(--iframe-gap);
        text-align: center;
        font-size: 10px;
        color: var(--iframe-text-secondary);
      "
    >
      You can manage trusted applications in your embarkAI settings.
    </span>
  </div>
</div>
